import { useMemo } from 'react';
import { Platform } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import { useModalStore } from '@/store';
import useKeyboardShortcuts from './useKeyboardShortcuts';

export default function useWorkKeyboardShortcuts({ isWorkMode, rootRef, focusedRef, isRunning, onSend, onSendNow }) {
  const isFocused = useIsFocused();
  const handlers = useMemo(() => {
    if (!isWorkMode || !isFocused) return {};
    const inComposer = event => {
      if (useModalStore.getState().isOpen) return false;
      if (Platform.OS !== 'web') return !!focusedRef?.current;
      const target = event?.target;
      // Never send a background draft from a dialog, document editor, or browser viewer.
      return !!target?.matches?.('textarea[data-gab-composer]') && !!rootRef.current?.contains(target);
    };
    const run = action => event => {
      if (!inComposer(event)) return false;
      action?.();
      return true;
    };
    return {
      WORK_SEND: run(onSend),
      WORK_SEND_NOW: run(() => { if (isRunning) onSendNow?.(); }),
    };
  }, [isWorkMode, isFocused, rootRef, focusedRef, isRunning, onSend, onSendNow]);
  useKeyboardShortcuts(handlers);
}
